module.exports = __webpack_public_path__ + "static/media/sun.0c9424d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sun.svg
// module id = 352
// module chunks = 1